import { updateSectionData } from '../../../handlers/utils';

const set_teaser = (teasers_kv, teasers, questions, values, index) => {
  for (let i = 0; i < teasers_kv.length; i++) {
    const teaser_kv = teasers_kv[i].split('=');
    const teaser_name = teaser_kv[0];
    const teaser_field = teaser_kv[1];
    for (let j = 0; j < questions.length; j++) {
      const qObj = questions[j];
      if (qObj.qid === teaser_field) {
        let teaser_str = Array.isArray(values.jobSeekerData[index][teaser_field])
          ? values.jobSeekerData[index][teaser_field][0]
          : values.jobSeekerData[index][teaser_field];
        teaser_str = (teaser_str != null) ? teaser_str.toString() : '';
        teasers[teaser_name] = teaser_str ? teaser_str.replaceAll('-', ' ') : teaser_str;
 break;
      }
    }
  }
};
export const handleEditable = (stateProps, index, step = 0) => {
  stateProps.setStep(step);

  updateSectionData({ sectionIndex: index }, stateProps);
  stateProps.setEditableIndex(index);
};
export const setTeasers = (sections, values, index) => {
  let teasers = false;
  const teasers_raw = sections.teasers;
  if (typeof teasers_raw !== 'undefined') {
    teasers = {};
    const teasers_kv = teasers_raw.split(',');
    set_teaser(teasers_kv, teasers, sections.questions, values, index);
    set_teaser(teasers_kv, teasers, sections.question_parts, values, index);
  }
  teasers.dates = set_teaser_dates(teasers, values, index);
  return teasers;
};

const set_teaser_dates = (teasers, values, index) => {
  let start_date = '';
  let end_date = teasers.hasOwnProperty('end_year') ? 'Present' : '';
  if (teasers.start_month) {
    start_date = teasers.start_month;
  }
  if (teasers.start_year) {
    start_date = start_date + ' ' + teasers.start_year;
  }
  if (teasers.end_year) {
    if (teasers.end_month && teasers.end_month !== '') {
      end_date = teasers.end_month + ' ' + teasers.end_year;
    } else {
      end_date = teasers.end_year;
    }
  }
  if (values.jobSeekerData[index]['is_complete'] === 'yes') {
    end_date = 'Present';
  }
  return start_date === '' ? end_date : start_date + ' - ' + end_date;
};


export const checkHasIndustry = (sectionName, indCode, jobTitle) => {
  let hasIndustry = false;
  if (sectionName === 'professional-experience') {
    if (typeof indCode !== 'undefined' && indCode !== '' && indCode[0] !== '0' && typeof jobTitle !== 'undefined' && jobTitle !== '') {
      hasIndustry = true;
    }
  }
  return hasIndustry;
};